module.exports = __webpack_public_path__ + "img/project-null-icon.d048ba4b.png";